import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { StatCard } from '../../components/shared/StatCard';
import { PropertyCard } from '../../components/landlord/PropertyCard';
import { MOCK_PORTFOLIO_STATS, MOCK_PROPERTIES } from '../../utils/mockData';
import { motion } from 'framer-motion';
import { Building, Users, Wallet, TrendingUp } from 'lucide-react';
export function PortfolioOverview() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-3836">
      <Sidebar data-id="element-3837" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-3838">
        <DashboardHeader data-id="element-3839" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-3840">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-3841">
            <div className="mb-6 lg:mb-8" data-id="element-3842">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-3843">
                Portfolio Overview
              </h1>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-3844">
                Manage your properties and track performance.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8" data-id="element-3845">
              <StatCard title="Total Properties" value={MOCK_PORTFOLIO_STATS.totalProperties} icon={Building} color="blue" data-id="element-3846" />
              <StatCard title="Total Tenants" value={MOCK_PORTFOLIO_STATS.totalTenants} icon={Users} color="green" data-id="element-3847" />
              <StatCard title="Total Revenue" value={`₦${(MOCK_PORTFOLIO_STATS.totalRevenue / 1000000).toFixed(1)}M`} icon={Wallet} color="purple" data-id="element-3848" />
              <StatCard title="Occupancy Rate" value={`${MOCK_PORTFOLIO_STATS.occupancyRate}%`} icon={TrendingUp} color="orange" data-id="element-3849" />
            </div>

            <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4 truncate" data-id="element-3850">
              Your Properties
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-3851">
              {MOCK_PROPERTIES.map((property, idx) => <motion.div key={property.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.05
            }} data-id="element-3852">
                  <PropertyCard property={property} data-id="element-3853" />
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}